import React, { useState } from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';
import { HistoryDrawer } from '../HistoryDrawer';

/**
 * "View Edit History" trigger for the shared table-maintenance drawers. Defaults
 * to the engine's per-record endpoint (GET /tablemaint/{table}/{recno}/history),
 * but a master-detail table whose history is keyed by something other than the
 * row recno (e.g. Rate Zone Mileage, keyed by the rate zone) can pass an explicit
 * `endpoint` instead.
 */
const EditHistoryLink: React.FC<{ table?: string; recno?: number; endpoint?: string; label?: string; compact?: boolean }> = ({
  table, recno, endpoint, label, compact,
}) => {
  const [open, setOpen] = useState(false);
  const ep = endpoint ?? `/tablemaint/${table}/${recno}/history`;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        tabIndex={compact ? -1 : undefined}
        title={compact ? 'View Edit History' : undefined}
        className={compact
          ? 'p-1.5 text-gray-400 hover:text-blue-600 dark:hover:text-blue-400'
          : 'inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300'}
      >
        <ClockIcon className="w-4 h-4" />{!compact && ' View Edit History'}
      </button>
      <HistoryDrawer
        isOpen={open}
        onClose={() => setOpen(false)}
        endpoint={open ? ep : null}
        title={label ? `Edit History — ${label}` : 'Edit History'}
      />
    </>
  );
};

export default EditHistoryLink;
